var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRightGreen2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 22,
  fill: "none",
  viewBox: "0 0 16 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "m0 21.41 16-10.375L0 .659z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 16,
  x2: 0,
  y1: 11.035,
  y2: 11.035,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#008129"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#008228"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#00A312"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#00B704"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00BF00"
})))));
export { SvgArrowRightGreen2 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAxNiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMjEuNDEwN0wxNiAxMS4wMzQ5TDAgMC42NTkxOFYyMS40MTA3WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzQ2M181ODIpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfNDYzXzU4MiIgeDE9IjE2IiB5MT0iMTEuMDM0OSIgeDI9IjAiIHkyPSIxMS4wMzQ5IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiMwMDgxMjkiLz4KPHN0b3Agb2Zmc2V0PSIwLjAxIiBzdG9wLWNvbG9yPSIjMDA4MjI4Ii8+CjxzdG9wIG9mZnNldD0iMC40MyIgc3RvcC1jb2xvcj0iIzAwQTMxMiIvPgo8c3RvcCBvZmZzZXQ9IjAuNzciIHN0b3AtY29sb3I9IiMwMEI3MDQiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMDBCRjAwIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";